var _mask, _path, _line, _line2, _mask2, _path2, _path3, _rect, _line3, _line4, _line5, _line6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesignIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 66,
    viewBox: "0 0 70 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_206_241",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 23L8.71778 0L0 23V23V66H17.5V23V23Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71778 0L11.5204 -1.07015L8.70745 -8.43709L5.91253 -1.06328L8.71778 0ZM17.5 23H20.5V22.4467L20.3026 21.9298L17.5 23ZM0 23L-2.80525 21.9367L-3 22.4505V23H0ZM0 66H-3V69H0V66ZM17.5 66V69H20.5V66H17.5ZM5.91514 1.07015L14.6974 24.0701L20.3026 21.9298L11.5204 -1.07015L5.91514 1.07015ZM2.80525 24.0633L11.523 1.06328L5.91253 -1.06328L-2.80525 21.9367L2.80525 24.0633ZM3 23V23H-3V23H3ZM3 66V23H-3V66H3ZM17.5 63H0V69H17.5V63ZM14.5 23V66H20.5V23H14.5ZM14.5 23V23H20.5V23H14.5Z",
    fill: "black",
    mask: "url(#path-1-inside-1_206_241)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.25,
    y1: 22.75,
    x2: 16.25,
    y2: 22.75,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 24.25,
    x2: 8.5,
    y2: 65.5,
    stroke: "black",
    strokeWidth: 3
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_206_241",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7139 18.5572L34.9999 0L24.28 18.5674C23.1499 20.4466 22.5 22.6474 22.5 25C22.5 30.1256 25.585 34.5307 29.9996 36.4597V66H39.9996V36.4601C41.2413 35.9176 42.3778 35.1792 43.3702 34.284C43.4111 34.2471 43.4517 34.2099 43.4921 34.1725C43.6098 34.0636 43.7254 33.9524 43.839 33.8388C43.9623 33.7155 44.0828 33.5898 44.2006 33.4617C44.2383 33.4207 44.2758 33.3795 44.3129 33.338C46.2108 31.2197 47.3965 28.4501 47.4935 25.4057C47.4979 25.2706 47.5001 25.1353 47.5001 25H47.5C47.5 22.6432 46.8477 20.4387 45.7139 18.5572Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 0L37.5979 -1.5L34.9999 -6L32.4018 -1.5L34.9999 0ZM45.7139 18.5572L43.1158 20.0572L43.1299 20.0816L43.1444 20.1057L45.7139 18.5572ZM24.28 18.5674L26.8509 20.1134L26.8647 20.0905L26.8781 20.0674L24.28 18.5674ZM29.9996 36.4597H32.9996V34.4967L31.2008 33.7107L29.9996 36.4597ZM29.9996 66H26.9996V69H29.9996V66ZM39.9996 66V69H42.9996V66H39.9996ZM39.9996 36.4601L38.7986 33.711L36.9996 34.4969V36.4601H39.9996ZM43.3702 34.284L45.3797 36.5115L45.3797 36.5115L43.3702 34.284ZM43.4921 34.1725L41.4541 31.9711L41.4535 31.9716L43.4921 34.1725ZM43.839 33.8388L45.9603 35.9602L45.9603 35.9601L43.839 33.8388ZM44.2006 33.4617L41.993 31.4303L41.9925 31.4308L44.2006 33.4617ZM44.3129 33.338L42.0785 31.3361L42.0785 31.3362L44.3129 33.338ZM47.4935 25.4057L44.4951 25.3083L44.4951 25.3101L47.4935 25.4057ZM47.5001 25H50.5001V22H47.5001V25ZM47.5 25H44.5V28H47.5V25ZM32.4018 1.5L43.1158 20.0572L48.312 17.0572L37.5979 -1.5L32.4018 1.5ZM26.8781 20.0674L37.5979 1.5L32.4018 -1.5L21.6819 17.0674L26.8781 20.0674ZM25.5 25C25.5 23.2072 25.9937 21.5389 26.8509 20.1134L21.709 17.0214C20.3061 19.3544 19.5 22.0876 19.5 25H25.5ZM31.2008 33.7107C27.8395 32.2419 25.5 28.8908 25.5 25H19.5C19.5 31.3604 23.3306 36.8195 28.7984 39.2087L31.2008 33.7107ZM32.9996 66V36.4597H26.9996V66H32.9996ZM39.9996 63H29.9996V69H39.9996V63ZM36.9996 36.4601V66H42.9996V36.4601H36.9996ZM41.3606 32.0565C40.6048 32.7384 39.7405 33.2994 38.7986 33.711L41.2006 39.2092C42.742 38.5357 44.1509 37.6201 45.3797 36.5115L41.3606 32.0565ZM41.4535 31.9716C41.4228 32 41.3918 32.0283 41.3606 32.0566L45.3797 36.5115C45.4303 36.4659 45.4806 36.4199 45.5308 36.3734L41.4535 31.9716ZM41.7177 31.7175C41.6316 31.8036 41.5437 31.8881 41.4541 31.9711L45.5302 36.3739C45.6759 36.2391 45.8193 36.1012 45.9603 35.9602L41.7177 31.7175ZM41.9925 31.4308C41.9028 31.5284 41.8112 31.624 41.7176 31.7175L45.9603 35.9601C46.1134 35.8071 46.2629 35.6511 46.4088 35.4925L41.9925 31.4308ZM42.0785 31.3362C42.0502 31.3677 42.0217 31.3991 41.993 31.4303L46.4083 35.493C46.455 35.4423 46.5013 35.3912 46.5474 35.3398L42.0785 31.3362ZM44.4951 25.3101C44.4213 27.6229 43.523 29.7238 42.0785 31.3361L46.5473 35.3398C48.8986 32.7155 50.3716 29.2772 50.492 25.5013L44.4951 25.3101ZM44.5001 25C44.5001 25.1028 44.4985 25.2056 44.4951 25.3083L50.492 25.503C50.4974 25.3355 50.5001 25.1678 50.5001 25H44.5001ZM47.5 28H47.5001V22H47.5V28ZM43.1444 20.1057C44.0045 21.5329 44.5 23.204 44.5 25H50.5C50.5 22.0823 49.691 19.3445 48.2834 17.0087L43.1444 20.1057Z",
    fill: "black",
    mask: "url(#path-5-inside-2_206_241)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 25C46 26.4445 45.7155 27.8749 45.1627 29.2095C44.6099 30.5441 43.7996 31.7567 42.7782 32.7782C41.7567 33.7996 40.5441 34.6099 39.2095 35.1627C37.8749 35.7155 36.4445 36 35 36C33.5555 36 32.1251 35.7155 30.7905 35.1627C29.4559 34.6099 28.2433 33.7996 27.2218 32.7782C26.2004 31.7567 25.3901 30.5441 24.8373 29.2095C24.2845 27.8749 24 26.4445 24 25",
    stroke: "black",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.0005,
    y: 1.5,
    width: 14.5,
    height: 63,
    stroke: "black",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 14.75,
    x2: 63.118,
    y2: 14.75,
    stroke: "black",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 54.5001,
    x2: 63.118,
    y2: 54.5001,
    stroke: "black",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 41.25,
    x2: 63.118,
    y2: 41.25,
    stroke: "black",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: 28,
    x2: 63.118,
    y2: 28,
    stroke: "black",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design-icon.03f64b88ea50b6ffcbf2805598fe5439.svg";
export { ForwardRef as ReactComponent };